/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './content-block-mixed';
import '../card/card-heading';
import '../content-block/content-block-copy';
import '../content-block/content-block-heading';
import '../content-group/content-group-heading';
import '../content-group/content-group-copy';
import '../content-item/index';
import '../cta/card-link-cta';
import '../image/image';
import '../link-list/index';
import '../pictogram-item/index';
